import axios from 'axios'
import i18n from '../i18n';

export default {
    state: {
        programs: [],
        currentProgram: null,
        allowStep2: false,
        allowStep3: false,
        openSection: null,
        currentSection: null
    },
    mutations: {
        getPrograms(state, programs) {
            state.programs = programs;
        },
        findProgram(state, uniqueCode) {
            const foundProgram = state.programs.find(p => p.uniqueCode == uniqueCode);

            if (foundProgram) state.currentProgram = foundProgram;
        },
        setCurrentProgram(state, program) {
            state.currentProgram = program;
        },
        newProgram(state, program) {
            state.currentProgram = program;
            state.allowStep2 = true;
        },
        updateCurrentProgram(state, program) {
            state.currentProgram = {
                ...state.currentProgram,
                ...program
            }
        },
        newSection(state, section) {
            state.currentProgram.sections.push(section);
        },
        deleteSection(state, sectionId) {
            state.currentProgram.sections = state.currentProgram.sections.filter((el) => {
                return el.id != sectionId;
            })
        },
        setAllowStep3(state, allowStep3) {
            state.allowStep3 = allowStep3;
        },
        updateSectionsOrder(state, sections) {
            state.currentProgram.sections = sections.map((section, index) => {

                return {
                    ...section,
                    ordering: index + 1,
                }
            });
        },
        setOpenSection(state, section) {
            state.openSection = section;
        },
        updateSectionAssetsOrder(state, sectionAssets) {
            state.currentProgram.sections = state.currentProgram.sections.map((section) => {

                if (section.id == state.openSection.id) {
                    const updatedAssets = sectionAssets.map((asset, index) => {
                        return {
                            ...asset,
                            ordering: index + 1
                        }
                    })

                    return {
                        ...section,
                        assets: updatedAssets
                    }

                } else {
                    return {
                        ...section,
                    }
                }
            });

            state.openSection = state.currentProgram.sections.find(section => section.id == state.openSection.id);
        },
        editSection(state, updatedSection) {
            state.currentProgram.sections = state.currentProgram.sections.map(section => {
                if (section.id != updatedSection.id) {
                    return {
                        ...section
                    }
                } else {
                    return {
                        ...updatedSection
                    }
                }
            })
        },
        setCurrentSection(state, section) {
            state.currentSection = section;
        },
        resetProgramState(state) {
            state.currentProgram = null;
            state.allowStep2 = false;
            state.allowStep3 = false;
            state.openSection = null
        },
    },
    actions: {
        async getPrograms({ commit, rootState }) {
            try {
                let url = `${process.env.VUE_APP_BASE_URL}/programs/list`;
    
                
                if (rootState.auth.role === "superuser") {
                    const museumId = rootState.superuser.activeMuseum.id;
                    url += `?museumId=${museumId}`;
                }
    
                const res = await axios.get(url);
                
                commit("getPrograms", res.data.content);
            } catch (e) {
                console.error("Error fetching programs:", e);
                throw e;
            }
        },
        async getProgram({ commit }, programId) {
            try {
                const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/programs/${programId}`);

                commit("setCurrentProgram", res.data);
            } catch (e) {
                throw e;
            }
        },
        async newProgram({ commit }, program) {
            try {
                const res = await axios.post(`${process.env.VUE_APP_BASE_URL}/programs/`, program);

                commit("newProgram", res.data);
            } catch (e) {
                throw e;
            }
        },
        async newSection({ commit }, section) {
            try {
                const res = await axios.post(`${process.env.VUE_APP_BASE_URL}/sections/`, section);
                commit('setCurrentSection', res.data);
                commit('newSection', res.data);
            } catch (e) {
                throw e;
            }
        },
        async updateSection({ commit }, section) {
            let payload = {
                defaultTitle: section.defaultTitle,
                defaultLocale: section.defaultLocale,
                ordering: section.ordering,
                locales: section.locales
            }
            try {
                const res = await axios.put(`${process.env.VUE_APP_BASE_URL}/sections/${section.id}`, payload);
                commit('setCurrentSection', res.data);
            } catch (e) {
                throw e;
            }
        },
        async deleteSection({ commit }, section) {
            try {
                await axios.delete(`${process.env.VUE_APP_BASE_URL}/sections/${section.id}`);
                commit("deleteSection", section.id);
            } catch (e) {
                throw e;
            }
        },
        async submitNewProgram({ state, commit }) {
            let programId = state.currentProgram.id;
            let defaultLocale = state.currentProgram.defaultLocale;
            let defaultTitle = state.currentProgram.defaultTitle;

            try {
                await axios.put(`${process.env.VUE_APP_BASE_URL}/programs/${programId}`, {
                    programId: programId,
                    draft: false,
                    defaultLocale: defaultLocale,
                    defaultTitle: defaultTitle
                });

                commit("toggleSnackbar", {
                    open: true,
                    text: i18n.t('programAddedSuccessfully'),
                    color: "success"
                })
            } catch (e) {
                throw e;
            }
        },
        async editProgram({ commit }, program) {
            try {
                const res = await axios.put(`${process.env.VUE_APP_BASE_URL}/programs/${program.programId}`, {
                    ...program
                });

                commit("updateCurrentProgram", res.data);
            } catch (e) {
                throw e;
            }
        },
        async editSection({ rootState }, section) {
            if (rootState.auth.role == "superuser") {
                section.set("museumId", rootState.superuser.activeMuseum.id)
            }

            try {
                await axios.post(`${process.env.VUE_APP_BASE_URL}/admin/editSection`, section);
            } catch (e) {
                throw e;
            }
        },
        async sectionSounds({ rootState, commit }, sounds) {
            if (rootState.auth.role == "superuser") {
                sounds.set("museumId", rootState.superuser.activeMuseum.id)
            }

            try {
                const res = await axios.post(`${process.env.VUE_APP_BASE_URL}/admin/sectionSounds`, sounds);

                commit("editSection", res.data.section)
            } catch (e) {
                throw e;
            }
        },
        async deleteDraft({ commit }, programId) {
            try {
                await axios.delete(`${process.env.VUE_APP_BASE_URL}/programs/${programId}`);
                commit("toggleSnackbar", {
                    open: true,
                    color: "success",
                    text: i18n.t('programDraftDeleted')
                })
            } catch (e) {
                throw e;
            }
        }
    },
}
